import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-your-pregnancy',
  templateUrl: './your-pregnancy.component.html',
  styleUrls: ['./your-pregnancy.component.scss']
})
export class YourPregnancyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
